import type { Metadata } from "next";
import { CompatTool } from "@/components/compat-tool";

export const metadata: Metadata = {
  title: "So Sánh Duyên Phận — Tử Vi Số",
  description: "Phân tích duyên phận hai người — Địa Chi và Mệnh nặng nhất.",
};

type Props = { searchParams: Promise<{ y1?: string; g1?: string; y2?: string; g2?: string }> };

export default async function SoSanhDuyenPhan({ searchParams }: Props) {
  const sp = await searchParams;
  return (
    <CompatTool
      searchParams={sp}
      mode="couple"
      title="So Sánh Duyên Phận"
      hint="Phân tích duyên phận hai người — Địa Chi và Mệnh là yếu tố quyết định."
    />
  );
}
